/*
 * @Author: tangke
 * @Date: 2019-02-23 17:59:48
 * @Last Modified by: others
 * @Last Modified time: 2019-03-07 18:00:23
 * @课程详情页面下的Assistance弹窗
 */
<template>
  <v-dialog v-model="model" content-class="assistanceDialog">
    <v-card>
      <v-card-title class="title blue-title pa-3 pt-4 ml-2">
        I need help in class—{{info.CLID}}
        <div class="header-close" title="close" @click="model = false">
          <v-icon>close</v-icon>
        </div>
      </v-card-title>
      <!-- <v-expansion-panel v-model="pannel">
        <v-expansion-panel-content v-for="(item, index) in assistance.list"
                                   :key="'content'+ index"
                                   :class="{'light-blue darken-1': pannel === index, 'white--text': pannel === index }">
          <div slot="header">{{index + 1}}. {{item.PName}}</div>
          <v-card>
            <v-card-text class="grey lighten-3" v-html="item.DefaultSolution"></v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel> -->
      
      <v-layout class="assistance-list d-flex">
        <div class="list-item">
          <ul class="text-xs-center font-weight-bold pa-0 ma-0">
            <li v-for="(item,index) in assistance.types" :key="'type'+index" @click="typeIndex=index;childrenIndex=0">
              <div class="pt-4" :style="{'background-color':(typeIndex==index?'#E9F4FF':'')}">
                <img width="30px" :src="item.src" alt="">
                <p class="blue-title">{{item.type}}</p>
              </div>
            </li>
          </ul>
        </div>
        <template v-for="(items,index) in assistance.list">
          <div :key="index" v-show="typeIndex==index" class="pa-1">
            <template v-for="(item,ind) in items.Children">
              <v-btn 
                class="px-2 text-none problem-btn blue-title" 
                depressed 
                :color="childrenIndex==ind?'#FFDFDB':'rgba(224, 224, 224, 0.5)'" 
                :key="'label'+ind" 
                @click="childrenIndex = ind"
                >{{item.PName}}</v-btn>
            </template>
            <div class="pa-2 assistanceInfos blue-text-normal">
              <p v-html="assistance.list[typeIndex].Children[childrenIndex].DefaultSolution"></p>
              <div v-if="assistance.list[typeIndex].Children[childrenIndex].SamplePath" :class="assistance.list[typeIndex].Children[childrenIndex].SamplePath" class="sampleImg"></div> 
              <!-- <div class="pb-2" :key="ind" v-for="(item,ind) in assistance.list[typeIndex].Children[childrenIndex].Children">
                <p>{{ind+1}}: {{item.DefaultSolution}}</p>
                <div v-if="item.SamplePath&&item.SamplePath.Sample">
                  <div v-for="(img,index) in item.SamplePath.Sample" :key="index">
                    <div :class="img.Path" class="sampleImg"></div> 
                  </div>

                </div>
              </div> -->
            </div>
            <div></div>
          </div>
        </template>
      </v-layout>
      <template>
        <v-layout row class="pt-4 px-3" v-if="typeIndex === 1 || typeIndex === 5">
          <!-- <v-subheader class="screenshotTitle">
            Problem screenshot
          </v-subheader>
          <v-flex xs5 class="screenshotIpt">
            <input v-show="0" type="file" class="upload" @change="changeScreenshot" ref="inputer" multiple id="assistanceIdCardFile" accept=".jpg,.png,.jpeg,.gif" />
            <v-text-field v-model="screenshotFileName" single-line outline box class="body-2" disabled></v-text-field>
          </v-flex>
          <v-flex xs3 pl-2>
            <v-btn color="primary accent-4" class="text-none white--text" @click="uploadScreenshot">Select the file</v-btn>
          </v-flex> -->
          <v-flex xs8>
            <v-flex xs12>
                <v-subheader class="pa-0 form-title">Problem Screenshot</v-subheader>
            </v-flex>
            <input v-show="0" type="file" class="upload" @change="changeScreenshot" ref="inputer" multiple id="assistanceIdCardFile" accept=".jpg,.png,.jpeg,.gif" />
            <v-text-field 
                    v-model="screenshotFileName" 
                    single-line 
                    outline 
                    class="body-2" 
                    disabled></v-text-field>
          </v-flex>
          <v-flex xs4 pl-2>
              <v-btn class="text-none white--text blue-button upload-btn" @click="uploadScreenshot">
                      <v-icon dark left
                          >cloud_upload</v-icon>Click to Upload</v-btn>
          </v-flex>
        </v-layout>
        <v-card-text class="pb-0 message-text">
          <v-layout row wrap>
            <v-flex xs12>
              <v-flex xs12>
                  <v-subheader class="pa-0 form-title">Message</v-subheader>
              </v-flex>
              <v-textarea outline
                      no-resize
                      name="message"
                      v-model="message"
                      counter="400"
                      maxLength="400"
                      :error-messages="$v.message.$error?'The maximum number of input characters has been reached':''"
                      @input="$v.message.$touch()"
                      ></v-textarea>
            </v-flex>
          </v-layout>
          
        </v-card-text>
        <v-card-actions class="pa-4">
         <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <v-btn class="text-none red-button dialog-submit"
                    :loading="submitting"
                    @click="submit">Submit</v-btn>
              <v-btn class="text-none cancel-button"
                    @click="model=false">Cancel</v-btn>
            </v-flex>
        </v-layout>
      </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { CSAssistance, GetClassProblem, getClassProblemIncludeChildren } from '@/api/classtable.js'
import vmodel from '@/mixins/v-model'
import { createNamespacedHelpers } from 'vuex'
const namespace = 'classDetail'
const { mapGetters, mapActions } = createNamespacedHelpers(namespace)
import student from '../../assets/img/common/student.png'
import tools from '../../assets/img/common/tools.png'
import textbook from '../../assets/img/common/textbook.png'
import network from '../../assets/img/common/network.png'
import others from '../../assets/img/common/others.png'
import issues from '../../assets/img/common/issues.png'


import { _debounce, getCookie } from "@/utils/tools.js";
import { uploader } from "@/utils/patchUpload.js";

export default {
  computed: {
    ...mapGetters(['info']),
    // panneCode () {
    //   return this.pannel != null ? this.assistance.list[this.typeIndex].Children[this.childrenIndex].Code : null
    // }
  },
  name: 'assistance',
  mixins: [vmodel, validationMixin],
  validations(){
    return {
      message: { maxLength: maxLength(400) },
    }
  },
  props: {
    infoUsedAClassroom: {
      type: Boolean
    }
  },
  data: () => ({
    student:student,
    tools:tools,
    textbook:textbook,
    network:network,
    others:others,
    issues:issues,
    assistance: {
      types:[
        {src:student,type:'Student Issues'},
        {src:tools,type:'Teaching Tools'},
        {src:textbook,type:'Material Issues'},
        {src:network,type:'Connection'},
        {src:others,type:'Cancelling Class'},
        {src:issues,type:'Picture Issues'}

      ],
      list: []
    },
    submitting: false,
    message: '',
    pannel: null,
    typeIndex:0,
    childrenIndex:0,
    screenshotForm: {
        files: []
    },
    screenshotFileName: ''
  }),
  methods: {
    ...mapActions(['fetchInfo']),
    submit: _debounce(async function() {
      var mes = this.message
      var client = getCookie("client")
      var isclient=0
      if (client=="tutorclient"){
          isclient=1
      }
      var param = {
        CLID: this.info.CLID,
        Uid: this.info.StuUID,
        Status: this.assistance.list[this.typeIndex].Children[this.childrenIndex].Code,
        Toolstatus: 0,
        Desc: mes,
        Tuid: this.info.TUID,
        ClassTool: this.info.ClassTools,
        IsClient:isclient
      }
      
      if(this.typeIndex === 1 && this.screenshotForm.files == ''){
        this.$root.$alertTips('Problem screenshot is required.', '',{ icon: { default:true } });
        return
      }
      if(this.typeIndex === 1 && this.screenshotForm.files && this.screenshotForm.files[0].size > 4194304){
        this.$root.$alertTips('Picture should be less than 4MB', '',{ icon: { default:true } });
        return
      }

      if(this.typeIndex === 5 && this.screenshotForm.files == ''){
        this.$root.$alertTips('Problem screenshot is required.', '',{ icon: { default:true } });
        return
      }
      if(this.typeIndex === 5 && this.screenshotForm.files && this.screenshotForm.files[0].size > 4194304){
        this.$root.$alertTips('Picture should be less than 4MB', '',{ icon: { default:true } });
        return
      }
      
      var _this = this;
      function func(){
        return new Promise((resolve,reject)=>{
          // 学生没来，学生中途离开 短信+电话通知学生上课
          if(param.Status == 104 || param.Status == 106){
            _this.$root.$confirm(
                `The system will process this 'Assistance' automatically. Please make sure the type of 'Assistance' is correct.`,
                'default',
                {
                    awaitSubmit: true,
                })
            .then(({ result ,submitcomplete}) => {
                if (result) {
                  submitcomplete()
                  resolve(true)
                }else{
                  resolve(false)
                }
            })
          }else if(param.Status == 110 || param.Status == 112 || param.Status == 113){
            // 进不了教室/打开无应答/教室更新
            _this.$root.$confirm(
                `Please make sure the type of 'Assistance' is correct.`,
                'default',
                {
                    awaitSubmit: true,
                })
            .then(({ result ,submitcomplete}) => {
                if (result) {
                  submitcomplete()
                  resolve(true)
                }else{
                  resolve(false)
                }
            })
          }
          else{
            resolve(true)
          }
        })
      }
      let isContinue = await func()
      if(!isContinue){
        return
      }
      var fileArray=[]
      if((this.typeIndex === 1 || this.typeIndex === 5) && this.screenshotForm.files && this.screenshotForm.files.length>0){
          fileArray.push({
              key:'screenshotImg',
              file:this.screenshotForm.files
          })
      }
      if(fileArray.length>0){
          var _uploader=new uploader({
              module: "ProblemScreenshot",
              progressbar: this.$root.$progressbar,

          })
          
          let uploadResult = await _uploader.uploadBatchWithKey(fileArray)
          if(uploadResult.ErrorCode!=0){
              this.$root.$alert(uploadResult.Msg||'Upload fail.')
              return
          }
          var screenshotData = uploadResult.Body
          
          if(screenshotData && screenshotData['screenshotImg']){
              param.UploadPath = JSON.stringify(screenshotData['screenshotImg'][0])
          }
          
      }
      
      this.submitting = true
      if (param.Status == null) {
        this.$root.$alertTips('Please choose the reason.', 'error')
        this.submitting = false
        return
      }
      CSAssistance(param).then(res => {
        if (res > 0) {
          this.fetchInfo(this.info.CLID)
          this.$root.$alertTips('Submit complete!', 'success')
          // this.$toasted.success('Submit complete!')
          this.model = false
        }
      }).finally(() => {
        this.submitting = false
        this.initDialog()
      })
    }),
    uploadScreenshot() {
      document.getElementById("assistanceIdCardFile").click();
    },
    changeScreenshot(elemt) {
      this.screenshotForm.files = elemt.target.files;
      this.screenshotFileName = this.screenshotForm.files[0].name;
    },
    initDialog(){
      this.typeIndex = 0
        this.childrenIndex = 0
        this.message = ''
        this.screenshotForm.files = ''
        this.screenshotFileName= ''
    },
    getClassProblemIncludeChildren() {
      let classTool = this.infoUsedAClassroom ? 8 : 0
      getClassProblemIncludeChildren(classTool).then(res=>{
       res.forEach(item=>{
         return item.Children.forEach(i=>{
           if(i.Children != null){
             return i.Children.forEach(s=>{
               if(s.SamplePath){
                  let path = JSON.parse(s.SamplePath) //将返回的图片地址转为json对象
                  return s.SamplePath = path
               }
             })
           }
         })
       })
        this.assistance.list = res
      })
    }
  }, 
  watch: {
      model(value) {
        if (value) {
          this.getClassProblemIncludeChildren()
        }
      }
    }
}
</script>
<style lang="scss" scoped>
.assistance-submit{
  width: 140px;
}
.message-text{
  position: relative;
}
.assistance-list{
  width: 100%;
  border-top: 1px solid #F2F2F2;
  border-bottom: 1px solid #F2F2F2;
}
.assistance-list .list-item{
  width: 155px;
}
.assistance-list ul li{
  width: 155px;
  height: 105px;
  border-right: 1px solid #F2F2F2;
  cursor: pointer;
}
.assistance-list ul li div{
  height: 100%;
}
.assistance-list ul li:last-child{
  border-bottom: none;
}
.problem-btn{
  height: 24px;
  font-size: 13px;
  background:rgba(224, 224, 224, 0.5);
  border-radius:4px;
}
.screenshotTitle{
  color: rgba(0,0,0,.87);
}
.sampleImg{
    width: 100%;
    height: 300px;
    margin: 0 auto;
    margin-bottom: 1rem;
}
.tti_a_1_1{
    background: url(../../../public/assets/ttisample/tti_a_1_1.png);
    background-size: 100% 100%;
}
.tti_a_1_2{
  background: url(../../../public/assets/ttisample/tti_a_1_2.png);
  background-size: 100% 100%;

}
.tti_a_1_3{
  background: url(../../../public/assets/ttisample/tti_a_1_3.png);
  background-size: 100% 100%;
}
.tti_a_2_1{
  background: url(../../../public/assets/ttisample/tti_a_2_1.png);
  background-size: 100% 100%;
}
.tti_a_3_1{
  background: url(../../../public/assets/ttisample/tti_a_3_1.png);
  background-size: 100% 100%;
}
.tti_b_1_1{
  background: url(../../../public/assets/ttisample/tti_b_1_1.png);
  background-size: 100% 100%;
}
.tti_b_1_2{
  background: url(../../../public/assets/ttisample/tti_b_1_2.png);
  background-size: 100% 100%;
}
.tti_b_2_1{
  background: url(../../../public/assets/ttisample/tti_b_2_1.png);
  background-size: 100% 100%;
}
.tti_b_2_2{
  background: url(../../../public/assets/ttisample/tti_b_2_2.png);
  background-size: 100% 100%;
  width: 300px;
  height: 450px;
}
.tti_b_3_1{
  background: url(../../../public/assets/ttisample/tti_b_3_1.png);
  background-size: 100% 100%;
  width: 300px;
  height: 450px;
}
.tti_c_1_1{
  background: url(../../../public/assets/ttisample/tti_c_1_1.png);
  background-size: 100% 100%;
}
.tti_c_1_2{
  background: url(../../../public/assets/ttisample/tti_c_1_2.png);
  background-size: 100% 100%;
}
.tti_c_1_3{
  background: url(../../../public/assets/ttisample/tti_c_1_3.png);
  background-size: 100% 100%;
}
.tti_d_1_1{
  background: url(../../../public/assets/ttisample/tti_d_1_1.png);
  background-size: 100% 100%;
}
.assistanceInfos{
  height: 430px;
  overflow: auto;
}
.blue-title{
    @include font_color($font-color-theme);
}

</style>
<style>
.assistanceDialog{
    width: 900px;
    max-height: 100%!important;
}
.screenshotIpt .v-text-field--box>.v-input__control>.v-input__slot{
  min-height: 37px;
  margin-top: 6px;
}
.screenshotIpt .v-input input{
  max-height: 20px;
}
</style>